export const FORMAT = Object.freeze({
  EMPTY: "",
  NL: "\n"
});

export const ERROR = Object.freeze({
  AUTHENTICATION_FAILED: "Autenticazione fallita.",
  SERVER_ERROR: "Errore del server.",
  SERVER_CONNECTION_ERROR: "Errore di connessione al server.",
  SESSION_EXPIRED: "Sessione scaduta.",
  SERVICE_ACCESS_NOT_AUTHORIZED: "Accesso al servizio non autorizzato.",
  VOTING_ACCESS_NOT_AUTHORIZED: "Accesso al voto non autorizzato.",
  VERIFY_SCHEDULING: "Verificare gli orari e le modalità di voto.",
  VOTER_IDENTIFICATION: "Errore nell'identificazione del votante.",
  ELECTION_EVENT: "Evento elettorale non trovato.",
  OPEN_VOTING_SESSION: "Errore nell'apertura della sessione di voto.",
  CLOSE_VOTING_SESSION: "Errore nella chiusura della sessione di voto.",
  ELECTION_LIST: "Lista elezioni non trovata.",
  ELECTION: "Elezione non trovata.",
  CONTEST: "Contesto non trovato.",
  BALLOT_SIGNATURE: "Errore nell'invio del voto.",
  MAKE_ABSTENSION: "Errore nell'astensione dal voto.",
  BALLOT_TO_BALLOT_BOX: "Errore nell'inserimento del voto in urna.",
  BALLOT_DELETE: "Errore nell'astensione dal voto."
});
